const JUMPABLE = {
  position: {
    x: 0,
    y: 0
  },
  width: 1,
  height: 1,
  image: ''
}

export default JUMPABLE
